import { render, staticRenderFns } from "./ModelRow.vue?vue&type=template&id=0b7cfd84&scoped=true"
import script from "./ModelRow.vue?vue&type=script&lang=js"
export * from "./ModelRow.vue?vue&type=script&lang=js"
import style0 from "./ModelRow.vue?vue&type=style&index=0&id=0b7cfd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7cfd84",
  null
  
)

export default component.exports